export default __webpack_public_path__ + "static/media/hero.01170aa5.jpg";